import Modal from "components/atoms/modal";
import { TextSm } from "components/atoms/text";
import Btn from "components/atoms/buttons";

interface Props {
  onClose: () => void;
}

// 씬의 개수가 0일 때, 상품 검색 탭 누를 경우
const ModalImageGuide = ({ onClose }: Props) => {
  return (
    <Modal.Container className="w-[312px] p-10 rounded-16 text-center">
      <TextSm className="text-black-60% mb-5">
        이미지를 먼저 업로드해주세요.
      </TextSm>
      <Btn.Blue onClick={onClose} size="large" className="w-full">
        확인
      </Btn.Blue>
    </Modal.Container>
  );
};

export default ModalImageGuide;
